import { georgiaCountyPaths, georgiaCountyBubbles } from "./georgia-counties";

/**
 * Lookup key for BOTH sides of the feed <-> shape join. AP feeds send either "Appling" or
 * "Appling County", while georgia-counties.js uses the bare name, so the trailing " County"
 * is dropped before comparing.
 */
export const normalizeCountyKey = (name) =>
  String(name || "").toLowerCase().trim().replace(/\s+/g, " ").replace(/\s+county$/, "");

// key -> original-cased shape name (e.g. "dekalb" -> "DeKalb"). First entry wins.
const CANONICAL = {};
[...georgiaCountyPaths, ...georgiaCountyBubbles].forEach(({ name }) => {
  const key = normalizeCountyKey(name);
  if (!CANONICAL[key]) CANONICAL[key] = name;
});

/**
 * Display name WITHOUT the " County" suffix, so callers append " County" exactly once.
 * Prefers the canonical shape-list casing ("DeKalb", "McDuffie", "Ben Hill").
 */
export const getCountyDisplayName = (name) => {
  const key = normalizeCountyKey(name);
  if (!key) return "";
  if (CANONICAL[key]) return CANONICAL[key];

  const stripped = String(name).trim().replace(/\s+/g, " ").replace(/\s+county$/i, "");
  if (stripped !== stripped.toLowerCase()) return stripped;
  return stripped.replace(/\b\w/g, (c) => c.toUpperCase());
};
